import { createContext, useContext } from "react";

const FilterHighlightContext = createContext<string>("");

export const FilterHighlightProvider = FilterHighlightContext.Provider;

export function useFilterHighlight() {
  return useContext(FilterHighlightContext);
}
